import Step from "@fae/source/models/Step.js"

export default function HandleArmor() {
    return (stage) => {
        const steps = []
        // TODO: only clear the armor of units whose turn it is.
        Object.values(stage.units).forEach((unit) => {
            if(unit.armor > 0) {
                steps.push(Step.deltastage({
                    "unit": {
                        "key": unit.key,
                        "armor": 0
                    }
                }))
            }
        })
        return steps
    }
}
